function saveCustomRoute( state, action ) {
	return state;
}

function showCurrentRoute( state, action ) {
	const existingMethods =  action.payLoad.value.endpoints.map(endpoint => endpoint.method);

	return {
		...state,
		existingMethods: existingMethods,
		settings: action.payLoad.value
	};
}

export { saveCustomRoute, showCurrentRoute };